import Vue from 'vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { initSentry } from '../../sentry/main'
import App from '@/pages/planbkTemplatev2/index.vue'
import MyMixins from '@/pages/planbkTemplatev2/mixins'
import mgmtPreview from './base/mgmtPreview'
import store from '@/pages/planbkTemplatev2/store'

Vue.config.productionTip = false
Vue.mixin(MyMixins)
Vue.mixin(mgmtPreview)
initSentry(Vue)
/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  render: h => h(App)
})
